import { Modal } from 'antd';

import { Container, Content, ImgOwl, Message, Title } from '../../../components/PopupBasic/styles';
import { typeOwl } from '../../../interfaces/pet';
import { formatClock } from '../session/time';
import type { FinishResult } from '../session/useGameSession';
import { ActionButton, Actions, Stat, Stats } from './styles';
import type { FinishErrorView } from './translateFinishError';

export interface FinishModalProps {
  visible: boolean;
  result: FinishResult | null;
  seconds: number;
  error: FinishErrorView | null;
  busy?: boolean;
  onRetry: () => void;
  onClose: () => void;
  onHome: () => void;
}

/** Modal único de fim de jogo (todos os jogos), no visual do popup do portal. */
export const FinishModal = ({ visible, result, seconds, error, busy = false, onRetry, onClose, onHome }: FinishModalProps) => {
  const owl = error ? (error.kind === 'unknown' ? 'erro' : 'atencao') : 'sucesso';
  const title = busy ? 'Salvando…' : error ? 'Fim de jogo' : 'Parabéns!';

  return (
    <Modal
      title={null}
      footer={null}
      visible={visible}
      onCancel={onClose}
      bodyStyle={{ padding: 0 }}
      style={{ maxWidth: '90vw' }}
      destroyOnClose
    >
      <Container>
        <Content>
          <Title>{title}</Title>
          <ImgOwl style={{ height: '16vh' }} src={typeOwl[owl]} alt="" />
          {result && (
            <Stats>
              <Stat>
                <strong>{`${result.points}/${result.maxPoints}`}</strong>
                <span>pontos</span>
              </Stat>
              <Stat>
                <strong>{formatClock(seconds)}</strong>
                <span>tempo</span>
              </Stat>
              {result.correct !== undefined && result.total !== undefined && (
                <Stat>
                  <strong>{`${result.correct}/${result.total}`}</strong>
                  <span>acertos</span>
                </Stat>
              )}
            </Stats>
          )}
          {error && <Message role="alert">{error.message}</Message>}
        </Content>
        <Actions>
          {error?.kind === 'unknown' && (
            <ActionButton type="button" variant="primary" onClick={onRetry} disabled={busy}>
              Tentar de novo
            </ActionButton>
          )}
          <ActionButton type="button" variant="secondary" onClick={onClose}>
            Fechar
          </ActionButton>
          <ActionButton type="button" variant="primary" onClick={onHome}>
            Voltar ao início
          </ActionButton>
        </Actions>
      </Container>
    </Modal>
  );
};
